import { Link as RRLink, LinkProps as RRLinkProps } from "react-router-dom";

export type LinkProps = RRLinkProps;
export const Link = RRLink;
